import { useEventCallback } from '@cian/react-utils';
import { useState } from 'react';
import { useSize } from './useSize';
export const useExpander = _ref => {
  let {
    initialExpanded = false,
    onExpandedChange,
    size: definedSize
  } = _ref;
  const [expanded, setExpanded] = useState(initialExpanded);
  const handleToggle = useEventCallback(() => {
    setExpanded(prevState => {
      const nextState = !prevState;
      if (onExpandedChange) {
        onExpandedChange(nextState);
      }
      return nextState;
    });
  });
  const size = useSize(definedSize);
  return {
    expanded,
    onToggle: handleToggle,
    size
  };
};